"use client";

/** 헤더의 Google Play · App Store 바로가기. 로고는 기존 스토어 배지의 벡터를 쓴다. */
import { memo } from "react";

import { appStoreLinksStyles } from "./AppStoreLinks.styles";
import type { AppStoreLinksProps } from "./AppStoreLinks.types";

import { STORE_URLS } from "@/shared/config/site";
import { trackEvent } from "@/shared/lib/analytics/amplitude";
import { getOS } from "@/shared/lib/deepLink";

const STORES = [
  { platform: "android", label: "Get Fanwork on Google Play" },
  { platform: "ios", label: "Download Fanwork on the App Store" },
] as const;

const AppStoreLinks = memo<AppStoreLinksProps>(({ placement }) => (
  <div className={appStoreLinksStyles.root}>
    {STORES.map(({ platform, label }) => (
      <a
        key={platform}
        href={STORE_URLS[platform]}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        title={label}
        className={appStoreLinksStyles.link}
        onClick={() =>
          trackEvent("Get App Clicked", {
            placement,
            os: getOS(),
            store: platform,
          })
        }
      >
        <svg
          viewBox="10 8 40 40"
          className={appStoreLinksStyles.icon}
          aria-hidden="true"
          focusable="false"
        >
          {platform === "android" ? (
            <>
              <path
                d="M15.9075 10.5416C15.5075 10.3029 15 10.591 15 11.0568V45.9432C15 46.409 15.5075 46.6971 15.9075 46.4584L45.1366 29.0152C45.5267 28.7825 45.5267 28.2175 45.1366 27.9848L15.9075 10.5416Z"
                fill="currentColor"
              />
              <path
                d="M18 11.7568L40 34.7568M15 46L37 23"
                className={appStoreLinksStyles.playSeam}
                strokeWidth="2"
              />
            </>
          ) : (
            <>
              <path
                d="M37.8655 10C38.6354 14.4605 33.1826 17.7197 31.0624 18.8058C30.6789 19.0023 30.2566 18.7221 30.2994 18.2934C30.531 15.9737 31.7235 10.0002 37.8655 10Z"
                fill="currentColor"
              />
              <path
                d="M24.5273 18.2793C26.89 18.2793 28.8776 18.9807 30.0525 19.5174C30.769 19.8446 31.6238 19.8446 32.3403 19.5174C33.5152 18.9807 35.5027 18.2793 37.8654 18.2793C39.9333 18.2793 42.5623 19.3627 44.5345 21.5296C37.8655 26.5584 39.771 34.8375 46 37.0298C44.0113 42.3057 40.2308 45.8764 36.9127 45.8764C34.0545 45.8764 34.0546 44.5885 31.1964 44.5885C28.3382 44.5885 28.3382 45.8764 25.48 45.8764C20.7164 45.8764 15 38.5172 15 29.3181C15 21.9589 20.7164 18.2793 24.5273 18.2793Z"
                fill="currentColor"
              />
            </>
          )}
        </svg>
      </a>
    ))}
  </div>
));

AppStoreLinks.displayName = "AppStoreLinks";

export default AppStoreLinks;
